import configuration from "../../config/configurations"

/**
 * Expose all endpoints for 'panels'.
 */
export const configurationApi = api => ({
  getConfiguration: filters =>
    api.get("configuration", { ...filters }),
});

export const configurationApiMock = () => ({
  getConfiguration: filters =>
    Promise.resolve({
      data: configuration[0],
      ok: true
    }),
  /*{
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: configuration[0].dashboard,
          ok: true
        });
      }, 1000);
    });
  }*/

});


// WEBPACK FOOTER //
// ./src/services/api/ConfigurationApi.js